import { createContext, type PropsWithChildren } from 'react';

import type { Site } from '@/api/fe-api/domain/entities/site';

export const CommunicationCurrentSiteContext = createContext<Site | undefined>(
  undefined,
);

export type CommunicationCurrentSiteProviderProps = PropsWithChildren<{
  site?: Site;
}>;

export function CommunicationCurrentSiteProvider({
  site,
  children,
}: CommunicationCurrentSiteProviderProps) {
  return (
    <CommunicationCurrentSiteContext.Provider value={site}>
      {children}
    </CommunicationCurrentSiteContext.Provider>
  );
}
